











import Vue_, { VueConstructor } from "vue";
//import Vuex from "vuex";
import ChatWindow from "./ChatWindow.vue";
import { ChatService as TextChat } from "../../chat";
import { ChatService as VideoChat } from "../../videochat";
import { log } from "@/logging";

const myLoggingName = "KingEventsChat";

interface InjectedVideoChatVue {
	videoChatService: VideoChat;
	textChatService: TextChat;
}

export default (Vue_ as VueConstructor<Vue_ & InjectedVideoChatVue>).extend({
	name: "KingEventsChat",
	//store, // makes `this.$store` accessible to all child/descendant components
	props: {
		config: Object,
		analyticsContext: Object
	},
	components: {
		ChatWindow
	},
	inject: ["videoChatService", "textChatService"],
	data: function() {
		return {
			chatService: this.textChatService,
			videoService: this.videoChatService,
			localConfig: {} as any,
			isMounted: false
		};
	},
	mounted(): void {
		// Add { presenceInfo: { locations: ["lounge1", other places], checkForPresenceIn: [ "lounge1", other places]}}
		const locations: Array<string> = this.config.locations ?? new Array<string>();

		//this.chatService.establishConnection(this.config.url, locations);
		this.chatService.startWebSocket(this.config.url, locations);

		//this.chatService.establishWebSocketConnection(locations);

		this.localConfig = {
			...this.config,
			showConversationMembers: this.config.showConversationMembers ?? true,
			onlyShowConversations: this.config.onlyShowConversations ?? [],
			hideConversations: this.config.hideConversations ?? [],
			allowNameChange: this.config.allowNameChange ?? true,
			locations: this.config.locations ?? [],
			checkForPresenceIn: this.config.checkForPresenceIn ?? [],
			videoEnabled: this.config.videoEnabled ?? false
		};
		// override videoEnabled, if videoChatService is not configured
		//this.localConfig = tmpConfig;
		if (this.localConfig.videoEnabled) {
			let capturedVue = this;
			// There is something weird going on here, videoChatSerivce.config() should throw an exception when video config is not defined, but the then clause is being called.
			// Will figure this out later.
			try {
				this.videoChatService.startWebSocket(this.chatService.name);
				// the establish connnection call is redundant
				//this.videoChatService.establishWebSocketConnection(this.chatService.name);
			} catch (err) {
				log(myLoggingName, "turning off video due to configuration error " + err);
				capturedVue.localConfig.videoEnabled = false;
			} finally {
				this.isMounted = true;
			}
		} else {
			this.isMounted = true;
		}
		// if (this.localConfig.videoEnabled) {
		// 	this.videoChatService.establishConnection(this.chatService.name);
		// }
	},
	destroyed(): void {
		this.chatService.disconnect();
		if (this.localConfig.videoEnabled) {
			this.videoService.disconnect();
		}
	},
	methods: {
		apiDoneLoading() {
			// TODO Should be moved to chat service - or should the UI dictate whether conversations are retrieved?
			const accessibleConversations = this.chatService.getConversations(
				this.localConfig.onlyShowConversations,
				this.localConfig.hideConversations
			);
			if (accessibleConversations.length === 0) {
				log(myLoggingName, "No valid conversations found");
				return;
			}
			this.$store.commit("kingEventsChat/setSelectedConversationId", accessibleConversations[0].id);
		},
		changeUserName(name: string) {
			//TODO 	When we start using update user, call it. Then, later, have chat and video service talk directly to each other.
			if (this.localConfig.videoEnabled) {
				this.videoService.connect(name);
			}
		}
	},
	computed: {
		isDoneLoading(): boolean {
			return this.chatService.isDoneLoading;
		}
	},
	watch: {
		isDoneLoading: function(newValue, oldValue) {
			if (!oldValue && newValue) {
				this.apiDoneLoading();
			}
			// else if (oldValue && !newValue) {
			// 	const locations: Array<string> = this.config.locations ?? new Array<string>();
			// 	//this.chatService.establishConnection(this.config.url, locations);
			// 	// TODO Need to figure out what to do here - I don't think we need to reconnect to the websocket
			// 	// as the WebSocketManager is supposed to automatically manage that.
			// 	log("KingEventsChat", "Calling reconnect from isDownLoading watcher");
			// 	this.chatService.reconnect(locations);
			// }
		}
	}
});
